import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';

import { FireIcon } from '@sorare/core/src/atoms/icons/Fire';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandS } from '@sorare/core/src/atoms/typography';
import { Trapezoid } from '@sorare/core/src/atoms/ui/Trapezoid';

export const HotStreakTitle = () => {
  return (
    <Trapezoid
      style={{ '--background': 'var(--c-gradient-hotstreak)' } as CSSProperties}
    >
      <Horizontal center gap={0.5}>
        <FireIcon
          color={{ start: 'var(--c-black)', end: 'var(--c-black)' }}
          size={2}
        />
        <BrandS color="var(--c-black)">
          <FormattedMessage defaultMessage="Hot Streaks" />
        </BrandS>
      </Horizontal>
    </Trapezoid>
  );
};
